import * as tslib_1 from "tslib";
import { ShaderChunkBase } from "./ShaderChunkBase";
/**
 * EffectEnvMapChunk provides a material method to perform reflection mapping using cube maps.
 */
var EffectEnvMapChunk = (function (_super) {
    tslib_1.__extends(EffectEnvMapChunk, _super);
    /**
     * Creates a new EffectEnvMapChunk.
     */
    function EffectEnvMapChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     * @inheritDoc
     */
    EffectEnvMapChunk.prototype._initVO = function (chunkVO) {
        chunkVO.needsNormals = true;
        chunkVO.needsView = true;
        this._envMap = this._shader.getAbstraction(this._method.envMap);
        if (this._method.mask) {
            this._maskMap = this._shader.getAbstraction(this._method.mask);
            this._shader.uvDependencies++;
        }
        else if (this._maskMap) {
            this._maskMap = null;
        }
    };
    /**
     * @inheritDoc
     */
    EffectEnvMapChunk.prototype.dispose = function () {
        this._envMap = null;
        this._maskMap = null;
    };
    /**
     * @inheritDoc
     */
    EffectEnvMapChunk.prototype._activate = function () {
        this._envMap.activate();
        if (this._maskMap)
            this._maskMap.activate();
        if (this._invalid)
            this._updateProperties();
    };
    EffectEnvMapChunk.prototype._setRenderState = function (renderable, projection) {
        this._envMap._setRenderState(renderable);
        if (this._maskMap)
            this._maskMap._setRenderState(renderable);
    };
    /**
     * @inheritDoc
     */
    EffectEnvMapChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var alphaRegister = registerCache.getFreeFragmentConstant();
        var code = "";
        this._fragmentIndex = alphaRegister.index * 4;
        var temp = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp, 1);
        var temp2 = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp2, 1);
        // r = I - 2(I.N)*N
        code += "dp3 " + temp + ".w, " + sharedRegisters.viewDirFragment + ".xyz, " + sharedRegisters.normalFragment + ".xyz\n" +
            "add " + temp + ".w, " + temp + ".w, " + temp + ".w\n" +
            "mul " + temp + ".xyz, " + sharedRegisters.normalFragment + ".xyz, " + temp + ".w\n" +
            "sub " + temp + ".xyz, " + temp + ".xyz, " + sharedRegisters.viewDirFragment + ".xyz\n" +
            this._envMap._getFragmentCode(temp, registerCache, sharedRegisters, temp) +
            "sub " + temp2 + ".w, " + temp + ".w, fc0.x\n" +
            "kil " + temp2 + ".w\n" +
            "sub " + temp + ", " + temp + ", " + targetReg + "\n";
        if (this._maskMap) {
            code += this._maskMap._getFragmentCode(temp2, registerCache, sharedRegisters, sharedRegisters.uvVarying) +
                "mul " + temp + ", " + temp2 + ", " + temp + "\n";
        }
        code += "mul " + temp + ", " + temp + ", " + alphaRegister + ".x\n" +
            "add " + targetReg + ", " + targetReg + ", " + temp + "\n";
        registerCache.removeFragmentTempUsage(temp);
        registerCache.removeFragmentTempUsage(temp2);
        return code;
    };
    EffectEnvMapChunk.prototype._updateProperties = function () {
        this._shader.fragmentConstantData[this._fragmentIndex] = this._method.alpha;
    };
    return EffectEnvMapChunk;
}(ShaderChunkBase));
export { EffectEnvMapChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/EffectEnvMapChunk.js